import { render, staticRenderFns } from "./QueueHome.vue?vue&type=template&id=0c8c29c0&"
import script from "./QueueHome.vue?vue&type=script&lang=ts&"
export * from "./QueueHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports